import _styled from "@emotion/styled/base";
import { css } from '@emotion/react';
import { getResetByTag, utilityStyles, rem } from './../../../styles';
var defaultStyles = function defaultStyles() {
  return /*#__PURE__*/css("border-radius:", rem(18), ";bottom:0;left:0;position:absolute;right:0;top:0;transition:box-shadow 0.2s ease,opacity 0.2s ease;" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
};
var resetStyles = getResetByTag('div');
var StyledButtonGroupItemOutline = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "esreui00"
} : {
  target: "esreui00",
  label: "StyledButtonGroupItemOutline"
})(resetStyles, defaultStyles, utilityStyles);
export default StyledButtonGroupItemOutline;